document.addEventListener('DOMContentLoaded', (event) => {
    const forms = document.querySelectorAll('form.only-submit-once');

    forms.forEach(form => {
        let isFormSubmitted = false;

        form.addEventListener('submit', (e) => {
            if (isFormSubmitted) {
                e.preventDefault();
                alert('Le formulaire a déjà été soumis. Merci de ne pas soumettre à nouveau.');
            } else {
                isFormSubmitted = true;
            }
        });
    });
});